import classNames from 'classnames';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import React from 'react';

import Link from 'components/Link';
import { content as contentPropType } from 'lib/CustomPropTypes';
import { isBefore } from 'lib/DateTime';
import getLink from 'lib/getLiveBlogEmbeddedLink';
import PinnedLabel from '../PinnedLabel/index';
import TimeAgo from '../TimeAgo/index';

const ONE_MINUTE = 60000; // Milliseconds
// lbp = live-blog-pkg

function Card({
  content,
  isBreaking,
  isEmbedded,
  showTimestamp,
}) {
  const isCurationPackage = !!content.computedValues;
  const autofilled = get(content, 'autofilled', true);
  const isPinnedPost = !autofilled;

  let headline;
  let url;
  let pinnedLabel;
  let publishedAt;
  if (isCurationPackage) {
    headline = get(content, 'computedValues.headline');
    url = get(content, 'computedValues.url');
    pinnedLabel = get(content, 'metadata.pinnedLabel');
    publishedAt = get(content, 'item.date.publishedAt', {});
  } else {
    headline = get(content, 'headline.primary', null)
      || get(content, 'headline.social');
    url = get(content, 'url.primary');
    publishedAt = get(content, 'date.publishedAt', {});
  }

  const {
    id,
  } = content;
  const { href, deviceUrl } = getLink(url, id, isEmbedded);

  return (
    <li
      data-test="lbp-card"
      className={classNames(
        'lbp-card',
        {
          'lbp-card--breaking': isBreaking,
          'lbp-card--animate-in': isBefore(publishedAt, ONE_MINUTE),
          'lbp-card--large': !showTimestamp,
        },
      )}
    >
      {
        // Must send href as null since Link component uses deviceUrl as separate fallback prop
        /* eslint-disable jsx-a11y/anchor-is-valid */
      }
      <Link
        className="lbp-card__link"
        data-test="lbp-card__link"
        href={deviceUrl ? null : href} // use deviceUrl if embedded
        deviceUrl={deviceUrl}
      >
        {isPinnedPost && (
          <PinnedLabel
            label={pinnedLabel}
            isBreakingNews={isBreaking}
          />
        )}
        {!isPinnedPost && showTimestamp && (
          <TimeAgo
            displayDate={publishedAt}
          />
        )}

        <h5 className="lbp-card__headline" data-test="lbp-card__headline">
          {headline}
        </h5>
      </Link>
      {
        /* eslint-enable jsx-a11y/anchor-is-valid */
      }
    </li>
  );
}

Card.propTypes = {
  content: contentPropType.isRequired,
  isBreaking: PropTypes.bool,
  isEmbedded: PropTypes.bool,
  showTimestamp: PropTypes.bool,
};

Card.defaultProps = {
  isBreaking: false,
  isEmbedded: false,
  showTimestamp: true,
};

export default Card;
